import { render, staticRenderFns } from "./scrutineerForm.vue?vue&type=template&id=108ba7f4&scoped=true&"
import script from "./scrutineerForm.vue?vue&type=script&lang=js&"
export * from "./scrutineerForm.vue?vue&type=script&lang=js&"
import style0 from "./scrutineerForm.vue?vue&type=style&index=0&id=108ba7f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108ba7f4",
  null
  
)

export default component.exports